export default "__VITE_ASSET__BO8j7vK___"